import React from "react";
import Input from "../../../components/Input";
import TextArea from "../../../components/TextArea";
import { countWords } from "../wordCount";

/**
 * @param {{
 *  label: string,
 *  placeholder?: string,
 *  multiline?: boolean,
 *  required?: boolean,
 *  maxWords?: number,
 *  value: string,
 *  onChange: (value:string)=>void,
 *  showError?: boolean,
 * }} props
 */
const TextFieldStep = ({
  label,
  placeholder,
  multiline,
  required,
  maxWords,
  value,
  onChange,
  showError,
}) => {
  const Field = multiline ? TextArea : Input;
  const wordCount = countWords(value);
  const isOverLimit = Boolean(maxWords) && wordCount > maxWords;
  const isEmptyError = required && showError && (value ?? "").trim() === "";
  const errorCondition = isEmptyError || (showError && isOverLimit);

  const hintText = maxWords ? `${wordCount}/${maxWords} words` : undefined;

  return (
    <Field
      label={label}
      placeholder={placeholder}
      value={value ?? ""}
      onValueChange={(e) => onChange(e.target.value)}
      errorCondition={errorCondition}
      hintText={hintText}
      hintError={isOverLimit}
    />
  );
};

export default TextFieldStep;
